import { ContratTemplate } from "../../model/Model";
import { del, get, post, put } from "../api";

/**
 * Récupère tous les templates de contrats
 */
export async function getTemplates(): Promise<ContratTemplate[]> {
    try {
        const response = await get('/v1/templates');
        return response.data?.data || [];
    } catch (error) {
        console.error('Erreur lors de la récupération des templates:', error);
        return [];
    }
}

/**
 * Récupère un template par son ID
 */
export async function getTemplateById(templateId: number): Promise<ContratTemplate | null> {
    try {
        const response = await get(`/v1/templates/${templateId}`);
        return response.data?.data || null;
    } catch (error) {
        console.error('Erreur lors de la récupération du template:', error);
        return null;
    }
}

/**
 * Crée un nouveau template de contrat
 */
export async function ajouterTemplate(template: ContratTemplate): Promise<ContratTemplate> {
    try {
        const response = await post('/v1/templates', template);
        return response.data?.data || {};
    } catch (error) {
        console.error('Erreur lors de l\'ajout du template:', error);
        throw error;
    }
}

/**
 * Modifie un template existant
 */
export async function modifierTemplate(template: ContratTemplate): Promise<ContratTemplate> {
    try {
        if (!template.id) {
            throw new Error('L\'ID du template est requis pour la modification');
        }
        const response = await put(`/v1/templates/${template.id}`, template);
        return response.data?.data || {};
    } catch (error) {
        console.error('Erreur lors de la modification du template:', error);
        throw error;
    }
}

/**
 * Supprime un template (soft delete)
 */
export async function supprimerTemplate(templateId: number): Promise<void> {
    try {
        await del(`/v1/templates/${templateId}`);
    } catch (error) {
        console.error('Erreur lors de la suppression du template:', error);
        throw error;
    }
}

/**
 * Duplique un template existant
 */
export async function dupliquerTemplate(templateId: number): Promise<ContratTemplate> {
    try {
        const response = await post(`/v1/templates/${templateId}/duplicate`, {});
        return response.data?.data || {};
    } catch (error) {
        console.error('Erreur lors de la duplication du template:', error);
        throw error;
    }
}
